import axios from 'axios'
import { Container, Singleton } from 'typescript-ioc/es5'
import { action } from 'mobx'
import { SessionState } from '@pushly/aqe'
import { AppState } from '@halo/stores/app.state'
import { AppService } from '@halo/services/app.service'
import { UserDto } from '@halo/dtos/user.dto'
import { axiosFetch } from '@halo/_utils/axios'
import aqe from '@pushly/aqe'
import { AUTH0_AUTH_ROUTE_BASE, AUTH0_CLIENT_ID, LOGOUT_ROUTE } from '@halo/constants'
import { buildRouteFromHostname, shouldUseLegacyAuthHeader } from '@halo/_utils/session-helpers'
import { PushlyCookie } from '@halo/enums/pushly-cookie.enum'
import { broadcastLogout } from '@pushly/aqe/lib/utils/session/session-state-sync'

@Singleton
export class AuthService {
    private appState: AppState
    private sessionState: SessionState
    private appService: AppService

    public constructor() {
        this.appState = Container.get(AppState)
        this.sessionState = Container.get(SessionState)
        this.appService = Container.get(AppService)
    }

    @action.bound
    public async login(email: string, password: string) {
        const response = await axios.post(
            `${aqe.defaults.publicApiDomain}/auth/login`,
            {
                email,
                password,
            },
            {
                auth: false as any,
                bypassGlobalErrorHandlers: true,
            } as any,
        )

        const { data } = response.data

        if (shouldUseLegacyAuthHeader()) {
            window.localStorage.setItem(PushlyCookie.PLATFORM_COOKIE, response.data.token)
        }

        this.appState.currentUser = UserDto.fromApiResponse(data)

        await this.appState.fetchUserDependencies()
        this.sessionState.isAuthenticated = true
        this.appService.reset404State()
    }

    @action.bound
    public async logout(expired: boolean = false) {
        this.appService.setAppLoading()

        try {
            if (!expired) {
                await axiosFetch(
                    'post',
                    {
                        url: `${aqe.defaults.publicApiDomain}/auth/logout`,
                    },
                    'logout',
                )
            }
        } catch {}

        if (shouldUseLegacyAuthHeader()) {
            window.localStorage.removeItem(PushlyCookie.PLATFORM_COOKIE)
        }

        this.appState.currentUser = undefined
        this.appState.currentDomainJsonData = undefined
        this.sessionState.isAuthenticated = false

        this.appService.reset404State()

        // Notify other tabs to show session expired interstitial
        broadcastLogout()

        let redirectBase = aqe.defaults.internalPlatformDomain
        if (expired) {
            localStorage.setItem('refreshRedirectURI', location.pathname)
        }

        const nextRoute = buildRouteFromHostname(AUTH0_AUTH_ROUTE_BASE + LOGOUT_ROUTE)
        const nextHref = [`${nextRoute}?client_id=${AUTH0_CLIENT_ID}`, `returnTo=${redirectBase}`].join('&')

        location.assign(nextHref)
    }
}
